import uniqid from 'uniqid'
import { references } from '../../portfolio'
import './References.css'

const References = () => {
  if (!references.length) return null

  return (
    <section className='section references' id='references'>
      <h2 className='section__title'>References</h2>
      <ul className='reference-main-container'>
        {references.map((reference) => (
          <div className="reference-item-main-container">
            <div className="reference-item-container">
                <div>
                    <a href={reference.scholar}>
                        <p className="reference-title">{reference.name}</p>
                    </a>
                    <p className="reference-desc">{reference.description}</p>
                    <a href={`${'mailto:'}${reference.email}`}>
                        <p className="reference-email">Email: {reference.email}</p>
                    </a>
                    <a href={reference.homepage}>
                        <p className="reference-page">Homepage: {reference.homepage}</p>
                    </a>
                </div>
            </div>
          </div>
        ))}
      </ul>
    </section>
  )
}

export default References
